import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaInput from "../../../../components/common/BriaInput/BriaInput";
import FiboPopoverButton from "../Popover/FiboPopoverButton";
import styles from "./FiboNegativePrompt.module.scss";

export interface IFiboNegativePromptProps {
	onChange: (value: string) => void;
	value: string | undefined;
}

const FiboNegativePrompt = ({ onChange, value }: IFiboNegativePromptProps) => {
	const { t } = useTranslation("fibo", { keyPrefix: "lab.settings.negativePrompt" });

	const isDisabled = false;

	const getTooltip = () => {
		if (isDisabled) return t("disabledTooltip");
		return t("tooltip");
	};

	return (
		<FiboPopoverButton
			className={clsx(styles.negativePromptButton, {
				[styles.hasNegativePrompt]: value,
			})}
			tooltip={getTooltip()}
			buttonText={t("label")}
			disabled={isDisabled}
		>
			<Box className={styles.negativePromptContainer}>
				<Typography className={styles.negativePromptLabel}>{t("label")}</Typography>
				<BriaInput
					value={value}
					onChange={(e) => onChange(e.target.value)}
					height="28px"
					className={styles.negativePromptInput}
				/>
			</Box>
		</FiboPopoverButton>
	);
};

export default observer(FiboNegativePrompt);
